import { UserComponent } from '@craftjs/core';
import { FormGeneralProps, FormTitleProps } from './BaseControlTypes';
import { ReactNode } from 'react';
import { createId } from 'src/helpers/typeUtils';

export type FormRepeatableContainerProps = FormTitleProps &
  FormGeneralProps & {
    children?: ReactNode;
    dataKey: string;
    addButtonText: string;
  };

export const formRepeatableContainerDefaultProps: FormRepeatableContainerProps = {
  dataKey: createId(),
  addButtonText: 'Add new section',
  title: 'Title',
};

export type FormRepeatableContainerComponent = UserComponent<FormRepeatableContainerProps>;

export type FormRepeatableSectionProps = FormTitleProps &
  FormGeneralProps & {
    children?: ReactNode;
    dataKey: string;
  };

export const formRepeatableSectionDefaultProps: FormRepeatableSectionProps = {
  dataKey: createId(),
  sectionTitle: 'Section title',
  isCollapsible: true,
};

export type FormRepeatableSection = UserComponent<FormRepeatableSectionProps>;
